import type { FC } from 'react'

import type { StepButtonsProps } from '../types'
import { StepMarkerButtons } from './StepMarkerButtons'
import { StepSegyButtons } from './StepSegyButtons'

export const StepButtons: FC<StepButtonsProps> = props => {
  switch (props.uploadedFile?.entityType) {
    case 'marker': {
      return <StepMarkerButtons {...props} />
    }
    default: {
      return <StepSegyButtons {...props} />
    }
  }
}
